import types from './types';


const initialState = {
	loading: true,
	list: [],
	pinned: [],
	details: {},
	profile: {},
	students: [],
	schedule: []
};




export default (state = initialState, action) => {
	// eslint-ignore-next-line
	switch (action.type) {
		/* Set initial list of items  */
		case types.UPDATE_LIST: {
			let newPostDetails = state.details
			const list = action.payload;
			list.forEach(doc => newPostDetails[doc.id] = doc)
			return {
				...state,
				loading: false,
				list: action.payload,
				details: newPostDetails
			};
		}

		case types.UPDATE_PINNED:
			let newPinnedDetails = state.details
			const pinnedList = action.payload;
			pinnedList.forEach(doc => newPinnedDetails[doc.id] = doc)
			return {
				...state,
				loading: false,
				pinned: action.payload,
				details: newPinnedDetails
			};
		case types.CLEAR_LIST: {
			return initialState
		}

		case types.UPDATE_DETAILS: {
			return {
				...state,
				details: {...state.details, [action.payload.id]: action.payload}
			}
		}

		case types.UPDATE_SCHEDULE: {
			return {
				...state,
				schedule: action.payload
			}
		}
		default:
			return state;
	}
};
